import React from "react";
import { RouteComponentProps, navigate } from "@reach/router";
import { CallbackComponent } from "redux-oidc";
import userManager from "../../business/oidc/userManager";
import Loader from "../system/loader/Loader";

interface OidcCallbackProps extends RouteComponentProps {}

export const OidcCallback: React.FunctionComponent<
  OidcCallbackProps
> = props => {
  return (
    <CallbackComponent
      userManager={userManager}
      successCallback={user => {
      }}
      errorCallback={e => {
        navigate("/");
      }}
    >
    <Loader isLoading={true}><div style={{width:'100vw', height:'100vh'}}></div></Loader>  
    </CallbackComponent>
  );
};

export default OidcCallback;
